import { createAction } from 'Lib/reduxUtils';

import { FETCH_META, FETCH_META_ERROR, FETCH_META_REQUEST, FETCH_META_SUCCESS } from './constants';

export const fetchMeta = createAction(FETCH_META, (sendAppStartInfo: boolean = false) => ({
  sendAppStartInfo,
}));
export const fetchMetaRequest = createAction(FETCH_META_REQUEST);
export const fetchMetaSuccess = createAction(FETCH_META_SUCCESS, ({ result }: { result: any }) => ({
  result,
}));
export const fetchMetaError = createAction(FETCH_META_ERROR);
